import type { PiniaPlugin } from 'pinia';

export const analyticsPlugin: PiniaPlugin = ({ store }) => {
    if (store.$id === 'auth') {
        store.$onAction(({ name, args, after }) => {
            if (name !== 'setProperty') return;
            const payload = args[0] as { property?: string; reIdentify?: boolean };
            if (!payload.reIdentify || !['first', 'last', 'jobRole', 'useCase'].includes(payload.property || '')) {
                return;
            }
            after(() => {
                // eslint-disable-next-line @typescript-eslint/no-require-imports
                const { identify }: typeof import('@/plugins/analytics') = require('@/plugins/analytics');
                identify();
            });
        });
    }

    if (store.$id === 'userSettings') {
        store.$onAction(({ name, args, after }) => {
            if (name !== 'update') return;
            const settingName = (args[0] as { name?: string })?.name ?? '';
            if (!settingName.startsWith('discoverGetStartedPreferences')) return;
            after(() => {
                // eslint-disable-next-line @typescript-eslint/no-require-imports
                const { identify }: typeof import('@/plugins/analytics') = require('@/plugins/analytics');
                identify();
            });
        });
    }
};
